export const getLocalToken = (): string | null => {
  return localStorage.getItem('jwt')
}
